import { requestServerApi, serverApi } from '../api/api';
import { IS_DEMO } from '../config/env-config';
export type UserInfo = {
  nickName: string;
  userId: string;
  role: string;
};
type Action =
  | 'エラー'
  | '不明'
  | '権限確認(iOS)'
  | 'デバイス準備完了'
  | 'カメラボタン押下(ON->OFF)'
  | 'カメラボタン押下(OFF->ON)'
  | 'カメラ開始エラー'
  | 'カメラ停止エラー'
  | 'マイクボタン押下(Unmute->Mute)'
  | 'マイクボタン押下(Mute->Unmute)'
  | 'マイクボタン押下(AudioON)'
  | 'マイクボタン押下(AudioOFF)'
  | '入室ボタン押下'
  | 'カメラ切替ボタン押下'
  | 'カメラ切替エラー'
  | 'マイク切替ボタン押下'
  | 'マイク切替エラー'
  | 'スピーカー切替ボタン押下'
  | 'スピーカー切替エラー'
  | 'チャットボタン押下(Open)'
  | 'チャットボタン押下(Close)'
  | '画面共有開始エラー'
  | '画面共有ボタン押下(開始)'
  | '画面共有ボタン押下(終了)'
  | '退室ボタン押下'
  | '退室OKボタン押下'
  | '退室キャンセルボタン押下';

export type LessonEventLog = {
  action: Action;
  lessonId: string;
  userId: string;
  roomId: string;
  page: string;
  advancedInfo?: Record<never, string>;
};
interface ISendLoggerService {
  sendLog(eventLog: LessonEventLog): Promise<void>;
}
class SendLoggerServiceApp implements ISendLoggerService {
  async sendLog(eventLog: LessonEventLog): Promise<void> {
    try {
      await requestServerApi(() =>
        serverApi.userEventControllerLogLessonEvent({
          action: eventLog.action,
          currentPage: eventLog.page,
          timestampMillis: new Date().getTime(),
          userAgent: navigator.userAgent,
          lessonId: eventLog.lessonId,
          roomId: eventLog.roomId,
          options: JSON.stringify(eventLog.advancedInfo)
        })
      );
    } catch (error) {
      console.error(error);
    }
  }
}

class SendLoggerServiceDemo implements ISendLoggerService {
  async sendLog(eventLog: LessonEventLog): Promise<void> {
    console.log('Demo mode: sendLog called');
    console.log(eventLog);
  }
}
export const SendLoggerService: new () => ISendLoggerService = IS_DEMO ? SendLoggerServiceDemo : SendLoggerServiceApp;
